export const serviceName = 'providerGroups'

export default { serviceName }
